var _path, _ellipse, _path2, _path3, _ellipse2, _ellipse3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBody1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1146 1655C884.217 1655 672 1442.78 672 1181L672 914C672 652.217 884.217 440 1146 440C1407.78 440 1620 652.217 1620 914L1620 1181C1620 1442.78 1407.78 1655 1146 1655Z",
    fill: "#DFE3EC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2267,
    cy: 882.5,
    rx: 418,
    ry: 399.5,
    fill: "#FCCFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.44 381.564C1493.62 327.751 1493.62 240.504 1547.44 186.691L1907.52 -173.389C1961.33 -227.202 2048.58 -227.202 2102.39 -173.389C2156.2 -119.577 2156.2 -32.3291 2102.39 21.4834L1742.31 381.564C1688.5 435.376 1601.25 435.376 1547.44 381.564Z",
    fill: "#164550"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.44 181.184C1493.62 127.371 1493.62 40.1239 1547.44 -13.6886L1750.31 -216.564C1804.12 -270.376 1891.37 -270.376 1945.18 -216.564C1999 -162.751 1999 -75.504 1945.18 -21.6915L1742.31 181.184C1688.5 234.996 1601.25 234.996 1547.44 181.184Z",
    fill: "#FCCFDD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.5,
    cy: 122.5,
    rx: 278.5,
    ry: 265.5,
    fill: "#DFE3EC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 14.5,
    rx: 262,
    ry: 250.5,
    fill: "#FCCFDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody1);
export default __webpack_public_path__ + "static/media/body_1.77f14b8e9a824c5be77b5c5ae37dc08b.svg";
export { ForwardRef as ReactComponent };